"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectModelNetStatsSchema = void 0;
const zod_1 = require("zod");
const INetStats_1 = require("../CircuitStates/INetStats");
exports.ProjectModelNetStatsSchema = zod_1.default.record(zod_1.default.string(), INetStats_1.INetStatsSummarySchema);
//# sourceMappingURL=ProjectModelNetStats.js.map